export default __webpack_public_path__ + "static/media/coffee-and-cats.4fefef74.jpeg";